import { ArticleParagraph1, Image, Tooltip, UIText2 } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import { type TRatingHelp } from './types';

import styles from './RatingCard.css';

type TRatingCardProps = {
  place: string;
  placeLabel: string;
  description: string;
  icon: string;
  help: TRatingHelp | undefined;
};

export const RatingCard: FC<TRatingCardProps> = ({ place, placeLabel, description, icon, help }) => {
  return (
    <div className={styles['card']} data-testid="RatingCard">
      <div className={styles['place-wrapper']}>
        <div className={styles['place']}>
          <div className={styles['place-number']}>{place}</div>
          <ArticleParagraph1>{placeLabel}</ArticleParagraph1>
        </div>
        <div className={styles['icon']}>
          <Image alt={`${place} ${description}`} height={45} preloader={false} src={icon} width={45} />
        </div>
      </div>
      <div>
        <UIText2 display="inline">{description}</UIText2>
        {help && (
          <Tooltip header={help.title} theme="white" title={help.text}>
            <div className={styles['description-icon']}>
              <div className={styles['description-icon--inner']}>
                <IconFunctionalInformationCircle16 />
              </div>
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};
